module.exports = __webpack_public_path__ + "img/update2.25f0eee8.svg";